import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './assets/sass/style.scss'
import { auth } from './firebase'
import { createHead } from '@unhead/vue/client'

const head = createHead()

let app

auth.onAuthStateChanged(() => {
  if (!app) {
    app = createApp(App)
    app.use(router)
    app.use(store)
    app.use(vuetify)
    app.use(head)
    app.mount('#app')
  }
})
